import type { Patient, Reference } from '@medplum/fhirtypes'
import { Participant } from '@seen/core/models/patients/participant'
import type { JSX } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { PatientName } from '#src/components/patient/PatientName.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { useReference } from '#src/hooks/useReference.ts'

export function ParticipantNameplate({
  participant,
}: {
  participant: Reference<Patient> | string
}): JSX.Element {
  const participantReference = useReference(participant)
  const { data: instance } = useRead(Participant, participantReference)
  return (
    <div className="flex items-center gap-2">
      <Avatar profile={participantReference} size="icon" />
      <p>{instance && <PatientName participant={instance} />}</p>
    </div>
  )
}
